import React, { FC, useEffect, useState } from "react";
import { Card, Upload, Button, Tooltip } from "antd";
import { CheckOutlined, EyeOutlined, UploadOutlined } from "@ant-design/icons";

type ResponseDocumentUploadProps = {
  documentTypes: any[];
  documentUrls: any[];
  handleFileChange: any;
  handleOpen: any;
  portalSubmission: boolean;
  documentRequestResponseDocuments: any;
  handleSaveData: () => void;
  currentStage: any;
  activeKey: any;
  uploadFileList: any;
};

const ResponseDocumentUpload: FC<ResponseDocumentUploadProps> = ({
  documentTypes,
  documentUrls,
  handleFileChange,
  handleOpen,
  portalSubmission,
  documentRequestResponseDocuments,
  handleSaveData,
  currentStage,
  activeKey,
  uploadFileList,
}) => {
  const showData = currentStage?.visitStageId <= parseInt(activeKey);

  const [updatedDocumentUrls, setUpdatedDocumentUrls] = useState<any>();

  useEffect(() => {
    const uploadedDocumentUrls: any = documentUrls?.filter((document: any) =>
      documentRequestResponseDocuments["responseDocuments"]?.some(
        (doc: any) => doc?.label === document?.documentLabelType
      )
    );

    setUpdatedDocumentUrls(uploadedDocumentUrls);
  }, [documentRequestResponseDocuments, documentUrls]);

  const groupByLabelType = (docs: any[]) => {
    return docs?.reduce((acc: any, doc: any) => {
      const label = doc.documentLabelType;
      if (!acc[label]) acc[label] = [];
      acc[label].push(doc);
      return acc;
    }, {});
  };

  return (
    <div>
      <div
        style={{
          textDecoration: "underline",
          fontSize: "16px",
          margin: "16px 0",
          fontWeight: "bold",
          display: "flex",
          alignItems: "center",
          gap: 10,
        }}
      >
        Response Document Upload
        {showData && portalSubmission ? (
          <Tooltip title={"Submit Response Documents"}>
            <CheckOutlined onClick={handleSaveData} />{" "}
          </Tooltip>
        ) : (
          <></>
        )}
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(6, 1fr)", //repeat(auto-fit, minmax(300px, 1fr))
          gap: 10,
          opacity: portalSubmission ? 1 : 0.5,
          pointerEvents: portalSubmission ? "auto" : "none",
        }}
      >
        {documentRequestResponseDocuments?.["responseDocuments"]?.length > 0 &&
          documentRequestResponseDocuments?.["responseDocuments"]?.map(
            (docType: any) => {
              const matchingDocuments = documentUrls?.filter(
                (doc) => doc.documentLabelType === docType.label
              );

              if (matchingDocuments?.length > 0 && !docType?.multiple) {
                return null;
              }

              return (
                <div
                  key={docType.id}
                  style={{
                    border: "1px solid #eee",
                    padding: 10,
                    borderRadius: 8,
                    display: "flex",
                    alignItems: "center",
                    // gap: 8,
                  }}
                >
                  <Upload
                    multiple={docType?.multiple}
                    {...(docType?.multiple ? { fileList: uploadFileList } : {})}
                    showUploadList={false}
                    beforeUpload={() => false}
                    onChange={
                      handleFileChange &&
                      handleFileChange(docType?.labelId, docType?.multiple)
                    }
                    disabled={!portalSubmission}
                  >
                    <Button
                      icon={<UploadOutlined />}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        borderRadius: 0,
                        border: "none",
                        borderTopLeftRadius: "6px",
                        borderBottomLeftRadius: "6px",
                      }}
                      // disabled={!showData}
                      disabled={!portalSubmission}
                    >
                      {/* {docType.label}{" "}
                  {docType?.required ? (
                    <span style={{ color: "red" }}>*</span>
                  ) : (
                    <></>
                  )} */}
                    </Button>
                  </Upload>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <Button
                      style={{
                        borderRadius: 0,
                        border: "none",
                        paddingLeft: 0,
                        borderTopRightRadius: "6px",
                        borderBottomRightRadius: "6px",
                      }}
                      iconPosition={"end"}
                      // icon={
                      //   matchingDocuments?.length > 0 ? (
                      //     <EyeOutlined
                      //       style={{ marginLeft: "0.6rem" }}
                      //       onClick={() => {
                      //         handleOpen(
                      //           matchingDocuments?.[0]?.documentLabelType
                      //         );
                      //       }}
                      //     />
                      //   ) : (
                      //     <></>
                      //   )
                      // }
                    >
                      {docType.label}{" "}
                      {docType?.required ? (
                        <span style={{ color: "red" }}>*</span>
                      ) : (
                        <></>
                      )}
                    </Button>
                  </div>

                  {/* {matchingDocuments?.length > 0 && (
                <EyeOutlined
                  style={{ marginLeft: "0.6rem" }}
                  onClick={() => {
                    handleOpen();
                  }}
                />
              )} */}
                </div>
              );
            }
          )}
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(4, 1fr)",
          gap: 10,
          borderTop:
            updatedDocumentUrls?.length > 0 ? "1px solid gray" : "none",
        }}
      >
        {Object.entries(groupByLabelType(updatedDocumentUrls || []))?.map(
          ([labelType, docs]: [any, any]) =>
            docs.map((docType: any, idx: any) => (
              <div
                key={docType.id}
                style={{
                  border: "1px solid #eee",
                  padding: 10,
                  borderRadius: 8,
                  display: "flex",
                  alignItems: "center",

                  // gap: 8,
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Button
                    style={{
                      borderRadius: "6px",
                      border: "none",
                      paddingLeft: 20,
                      // borderTopRightRadius: "6px",
                      // borderBottomRightRadius: "6px",
                      background: docType?.deficiencyCheckStatus
                        ? "rgb(0, 109, 119)"
                        : docType?.deficiencyCheckStatus === "false" ||
                          docType?.deficiencyCheckStatus === false
                        ? "#DD2025"
                        : "#fff",
                      color:
                        docType?.deficiencyCheckStatus ||
                        docType?.deficiencyCheckStatus === false
                          ? "white"
                          : "black",
                    }}
                    iconPosition={"end"}
                    icon={
                      <EyeOutlined
                        style={{ marginLeft: "0.6rem" }}
                        onClick={() => {
                          handleOpen(docType?.documentLabelType, docType?.documentUrl);
                        }}
                      />
                    }
                  >
                    {docType?.documentLabelType} {idx + 1}{" "}
                  </Button>
                </div>
              </div>
            ))
        )}
      </div>
    </div>
  );
};

export default ResponseDocumentUpload;
